import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../client/components/ui/dialog";
import { Button } from "../../client/components/ui/button";
import useTranslation from "../../client/hooks/useTranslation";

export interface DeleteLayoutDialogProps {
  open: boolean;
  onOpenChange: (b: boolean) => void;
  layoutName: string;
  onConfirm: () => void;
}

export default function DeleteLayoutDialog({ open, onOpenChange, layoutName, onConfirm }: DeleteLayoutDialogProps) {
  const t = useTranslation();
  const confirmMsg = t.dashboard.layouts.deleteDialogConfirm.replace("{name}", layoutName);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.dashboard.layouts.deleteDialogTitle}</DialogTitle>
          <DialogDescription>{confirmMsg}</DialogDescription>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">{t.dashboard.layouts.deleteDialogWarning}</p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t.common.cancel}</Button>
          <Button variant="destructive" onClick={() => { onConfirm(); onOpenChange(false); }}>
            {t.dashboard.layouts.delete}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
